import { render, staticRenderFns } from "./Trophy.vue?vue&type=template&id=0699760a&scoped=true"
import script from "./Trophy.vue?vue&type=script&lang=js"
export * from "./Trophy.vue?vue&type=script&lang=js"
import style0 from "./Trophy.vue?vue&type=style&index=0&id=0699760a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699760a",
  null
  
)

export default component.exports